'use strict';

var cleanCID = require('../utils/clean-cid');

var TarStreamToObjects = require('../utils/tar-stream-to-objects');

var v = require('is-ipfs');

var through = require('through2');

var pull = require('pull-stream');

var toPull = require('stream-to-pull-stream');

var deferred = require('pull-defer');

module.exports = function (send) {
  return function (path, opts) {
    opts = opts || {};
    var p = deferred.source();

    try {
      path = cleanCID(path);
    } catch (err) {
      if (!v.ipfsPath(path)) {
        return p.end(err);
      }
    }

    var request = {
      path: 'get',
      args: path,
      qs: opts
    }; // Convert the response stream to TarStream objects

    send.andTransform(request, TarStreamToObjects, function (err, stream) {
      if (err) {
        return p.end(err);
      }

      var files = [];
      stream.pipe(through.obj(function (file, enc, next) {
        if (file.content) {
          files.push({
            path: file.path,
            content: toPull(file.content)
          });
        } else {
          files.push(file);
        }

        next();
      }, function () {
        return p.resolve(pull.values(files));
      }));
    });
    return p;
  };
};